import React from "react";
import { IMAGES } from "@/lib/site";
import { useContent } from "@/lib/content";

const About = () => {
  const c = useContent();
  const stats = [
    { value: c("about.stat1_v", "10"), label: c("about.stat1_l", "Acres of countryside") },
    { value: c("about.stat2_v", "2"), label: c("about.stat2_l", "Private carp lakes") },
    { value: c("about.stat3_v", "3"), label: c("about.stat3_l", "Lakeside lodges") },
    { value: c("about.stat4_v", "27"), label: c("about.stat4_l", "Camping pitches") },
  ];
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 bg-[#F5EFE6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-24 items-start">
          <div className="lg:col-span-5">
            <p className="overline text-[#6A5F58]" data-testid="about-overline">
              <span className="marker-line" />
              {c("about.overline", "The Park")}
            </p>
            <h2
              data-testid="about-title"
              className="font-serif text-4xl md:text-5xl mt-6 leading-[1.05] text-[#14100F]"
            >
              {c("about.title", "Once working farm turned into kids free place to breathe and relax.")}
            </h2>
            <p className="mt-8 text-[#3A322E] text-base md:text-lg leading-relaxed">
              {c(
                "about.body1",
                "Walnut Lakes sits just off the A16, in a quiet fold of Lincolnshire fenland outside Boston. What was once a family farm is now ten landscaped acres of open sky, stocked water and long country paths. The pace is deliberately unhurried — this is a park built for people who’d rather cast a line, walk the dog, and read on the deck than share a pool with a hundred strangers."
              )}
            </p>
            <p className="mt-6 text-[#3A322E] text-base md:text-lg leading-relaxed">
              {c(
                "about.body2",
                "We keep it small on purpose. Two lakes. A handful of lodges. A tidy touring field. And the kind of hush that only comes when the nearest thing to your window is a heron."
              )}
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="img-frame aspect-[4/3] shadow-sm">
              <img src={c("about.image") || IMAGES.trail} alt="Countryside walking trail" />
            </div>

            <div
              className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6"
              data-testid="about-stats"
            >
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="border-t border-[#DDD1BE] pt-5"
                  data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <div className="font-serif text-4xl text-[#0F0E0E] leading-none">
                    {s.value}
                  </div>
                  <div className="mt-2 text-xs uppercase tracking-[0.18em] text-[#6A5F58]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
